import { Vimeo } from "vimeo";

import { getPublicConfig } from "@/helpers/getPublicConfig";

const { isFeatureBranch, isProduction, vercelUrl, service } = getPublicConfig();

export const vimeoClient = new Vimeo(
  service.vimeo.clientId,
  service.vimeo.secretKey,
  service.vimeo.accessToken,
);

// Example: get video thumbnail (preview image)
export const getVideoTranscodeStatus = async (uri: string) => {
  return new Promise((resolve, reject) => {
    vimeoClient.request(
      uri + "?fields=transcode.status",
      (error, body, statusCode, headers) => {
        if (error) {
          reject(error);
        } else {
          resolve(body.transcode.status);
        }
      },
    );
  }) as Promise<string>;
};

export const isVideoTranscoded = async (uri: string) => {
  let status: string;
  try {
    status = await getVideoTranscodeStatus(uri);
  } catch (err) {
    // do something
  }
  if (status === "complete") {
    setVideoWhitelistDomain(uri);
    return true;
  }

  return false;
};

export const getVideoUrl = async (uri: string) => {
  try {
    const url = (await new Promise((resolve, reject) => {
      vimeoClient.request(
        uri + "?fields=link",
        function (error, body, statusCode, headers) {
          if (error) {
            reject(error);
          }
          resolve(body.link);
        },
      );
    })) as string;
    return url;
  } catch (err) {
    //TODO: err handling
    return null;
  }
};

export const modifyWhitelistDomain = async (
  uri: string,
  domain: string,
  method: "DELETE" | "PUT",
) => {
  return new Promise((resolve, reject) => {
    vimeoClient.request(
      {
        method,
        path: uri + `/privacy/domains/${domain}`,
      },
      (error, body, status_code, headers) => {
        if (error) {
          reject(error);
        }
        resolve(true);
      },
    );
  }) as Promise<boolean>;
};

export const setVideoWhitelistDomain = async (uri: string) => {
  const domainToAdd = [];

  // set production url && staging url
  if (isProduction) {
    domainToAdd.push(
      "www.dearshare.com",
      "dearshare.com",
      "staging.dearshare.com",
      "nft.dearshare.com",
    );
    return Promise.all(
      domainToAdd.map((domain) => modifyWhitelistDomain(uri, domain, "PUT")),
    );
  }

  // set feature branch url && preview
  if (isFeatureBranch) {
    const featureBranchDomain = window ? window.location.hostname : vercelUrl;
    domainToAdd.push(featureBranchDomain);
  }

  // default: set localhost && preview
  domainToAdd.push("localhost", "preview.dearshare.com");
  return Promise.all(
    domainToAdd.map((domain) => modifyWhitelistDomain(uri, domain, "PUT")),
  );
};
